import { render, staticRenderFns } from "./OrderItemsModal.vue?vue&type=template&id=7d54fe72&"
import script from "./OrderItemsModal.vue?vue&type=script&lang=js&"
export * from "./OrderItemsModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports